import React from 'react';
import { MantineProvider } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import NewAccessTicket from './pages/NewAccessTicket';
import MyTickets from './pages/MyTickets';
import NothingFoundPage from './pages/NothingFoundPage';
import RequestSubmitted from './pages/RequestSubmitted';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import SubmitTicket from './pages/SubmitTicket';
import UrgentIssue from './pages/UrgentIssue';
import Dashboard from './pages/Dashboard';
import TicketPage from './pages/Ticket';
import DeviceRequest from './pages/DeviceRequest'
import IncidentRequest from './pages/IncidentRequest';
import Layout from './common/Layout';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalProvider, MsalAuthenticationTemplate } from '@azure/msal-react';
import { msalConfig, loginRequest } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);
const authRequest = {
  ...loginRequest,
};

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
        <MantineProvider withNormalizeCSS withGlobalStyles theme={{ primaryColor: 'gray' }}>
          <NotificationsProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/new-access-ticket" element={<NewAccessTicket />} />
                  <Route path="/device-request" element={<DeviceRequest />} />
                  <Route path="/incident-request" element={<IncidentRequest />} />
                  <Route path="/my-tickets" element={<MyTickets />} />
                  <Route path="/ticket/:ticketId" element={<TicketPage />} />
                  <Route path="/change-password" element={<ChangePassword />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/submit-ticket" element={<SubmitTicket />} />
                  <Route path="/urgent-issue" element={<UrgentIssue />} />
                  <Route path="/request-submitted/:ticketId" element={<RequestSubmitted />} />
                  <Route path="*" element={<NothingFoundPage />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </NotificationsProvider>
        </MantineProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default App;
